const _temp0 = require("../About/About.js");

const _temp1 = require("../Flash/Flash.js");

const _temp2 = require("../Galerie/Galerie.js");

const _temp3 = require("../Home/Home.js");
const _temp4 = require("../Home/components/CustomModal/CustomModal.js");

const _temp5 = require("../Home/components/Gallery/Gallery.js");



const _temp6 = require("../Contact/Contact.js");

const _temp7 = require("../Rendezvous/Rendezvous.js");

module.exports = {
  "About":   {
    "About": _temp0
  },
  "Flash":   {
    "Flash": _temp1
  },
  "Galerie":   {
    "Galerie": _temp2
  },
  "Home":   {
    "Home": _temp3,
    "components":     {
      "CustomModal":       {
        "CustomModal": _temp4
      },
      "Gallery":       {
        "Gallery": _temp5
      }
    }
  },
  "Contact":   {
    "Contact": _temp6
  },
  "Rendezvous":   {
    "Rendezvous": _temp7
  }
}